import Vue from 'vue'
import SwitchSetDialog from './switchSetDialog.vue'

const SwitchBox = Vue.extend(SwitchSetDialog);

SwitchSetDialog.install = function (data) {
  let instance = new SwitchBox({
    data
  }).$mount();

  document.body.appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.show = true
    // show 和弹窗组件里的show对应，用于控制显隐
  })
};

export default SwitchSetDialog



// WEBPACK FOOTER //
// ./src/components/popup/switchSetDialog.js